module.exports = __webpack_public_path__ + "static/scale-model-of-belmont-mansion-visitor-parking-in-nashville-tennessee-fee8284c0a0d7ce7cb1823bf96661fac.png";